import React from 'react';

const PaymentCancelled = () => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
    <div className="bg-white p-8 rounded shadow-md text-center">
      <h1 className="text-2xl font-bold text-red-600 mb-4">Payment Cancelled</h1>
      <p className="text-gray-700 mb-4">Your payment was cancelled. No charges were made. You can try again from the plans page.</p>
      <a href="/plans" className="text-blue-600 hover:underline">Back to Plans</a>
    </div>
  </div>
);

export default PaymentCancelled; 
